module.exports = new __parcel__URL__("template-roadmap-icon.72864c5e.svg").toString();